'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/logo.js';
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _omit = require('lodash/omit');
var _omit2 = _interopRequireDefault(_omit);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _withHeaderTheme = require('../hocs/with-header-theme');
var _withHeaderTheme2 = _interopRequireDefault(_withHeaderTheme);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var headerStyle = _themes.componentThemes.header.headerStyle;
Logo.propTypes = {
  theme: _propTypes.object.isRequired,
  link: _propTypes.string,
  padding: (0, _propTypes.shape)({
    left: _propTypes.string,
    right: _propTypes.string,
    top: _propTypes.string,
    bottom: _propTypes.string
  }),
  small: _propTypes.bool,
  isLoggedIn: _propTypes.bool
};
Logo.defaultProps = {
  link: undefined,
  padding: {},
  small: false
};
function Logo(_ref) {
  var theme = _ref.theme,
    link = _ref.link,
    padding = _ref.padding,
    small = _ref.small,
    isLoggedIn = _ref.isLoggedIn,
    rest = _objectWithoutProperties(_ref, ['theme', 'link', 'padding', 'small', 'isLoggedIn']);
  var _padding$top = padding.top,
    paddingTop = _padding$top === undefined ? theme[headerStyle('logoTopBottomPadding')] : _padding$top,
    _padding$right = padding.right,
    paddingRight = _padding$right === undefined ? '20px' : _padding$right,
    _padding$bottom = padding.bottom,
    paddingBottom = _padding$bottom === undefined ? theme[headerStyle('logoTopBottomPadding')] : _padding$bottom,
    _padding$left = padding.left,
    paddingLeft = _padding$left === undefined ? '0' : _padding$left;
  var logo = _react2.default.createElement(_glamorous.Img, {
    src: small && typeof theme.logo_small !== 'undefined' ? theme.logo_small : theme.logo,
    alt: 'Marmalade',
    height: '60px',
    padding: paddingTop + ' ' + paddingRight + ' ' + paddingBottom + ' ' + paddingLeft,
    display: 'block',
    maxWidth: 'inherit',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  });
  var logoLink = link === undefined ? theme.logo_link : link;
  if (isLoggedIn && theme.account_link && link === undefined) {
    logoLink = theme.account_link;
  } else if (window.location.pathname.includes('/payment-success') && theme.login_link) {
    logoLink = theme.login_link;
  }
  if (logoLink) {
    return _react2.default.createElement('a', Object.assign({
      href: logoLink
    }, (0, _omit2.default)(rest, ['dispatch', 'theme']), {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58
      },
      __self: this
    }), logo);
  }
  return logo;
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoggedIn: !!state.account.auth.refreshToken
  };
};
exports.default = (0, _withHeaderTheme2.default)((0, _reactRedux.connect)(mapStateToProps, null)(Logo));